// Estilos compartidos de avatar (gradientes + iniciales) y chips de curso
// usados en Home (RecentUsers) y Alumnos (Customers) para mantener el
// mismo lenguaje visual del rediseño Datofy V1.

export const AVATAR_GRADIENTS = [
  'linear(140deg, #F2683C, #D8401A)',
  'linear(140deg, #7E63D6, #5A3FB5)',
  'linear(140deg, #2FA6A0, #147F77)',
  'linear(140deg, #E8893C, #C56516)',
  'linear(140deg, #5B86E5, #3A66C8)',
  'linear(140deg, #D8588E, #B23A6E)'
];

export const getInitials = (name) => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

// Paletas pasteles disponibles para chips (definidas en theme/styles.js).
// 'coral' usa coral.soft/coral.700 en vez de coral.bg/coral.ink.
const COURSE_CHIP_PALETTES = ['coral', 'mint', 'sky', 'butter', 'lav', 'rose', 'teal', 'amber'];

// Hash determinístico simple: mismo curso -> mismo color siempre.
export const getCourseChipPalette = (groupName) => {
  const str = (groupName || '').trim();
  if (!str) return COURSE_CHIP_PALETTES[0];

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }

  return COURSE_CHIP_PALETTES[hash % COURSE_CHIP_PALETTES.length];
};

// Devuelve { bg, color } listos para usar en props de Chakra.
export const getCourseChipColors = (groupName) => {
  const palette = getCourseChipPalette(groupName);
  if (palette === 'coral') {
    return { bg: 'coral.soft', color: 'coral.700' };
  }
  return { bg: `${palette}.bg`, color: `${palette}.ink` };
};
